import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Menu,
  MultiSelect,
  MultiSelectProps,
  rem,
  ScrollArea,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import {
  useDebouncedCallback,
  useDebouncedValue,
  useDisclosure,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconCalendar,
  IconCheck,
  IconFileExport,
  IconSearch,
  IconTrademark,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { _localization } from "../../../config/location";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { MessageResponse } from "../../../model/MessageResponse";
import { InventorySerialItem } from "../../../model/ReportInventoryBySerial";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { BASE_API_DELIVERY } from "../../../config";

const ReportInventoryBySerial = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<InventorySerialItem[]>([]);
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
  const [dataSaleChannel, setDataBranchCode] = useState<any[]>(
    []
  );
  const [searchCatSegment3c, setSearchCatSegment3c] = useState("");
  const [debouncedCatSegment3c] = useDebouncedValue(searchCatSegment3c, 500);
  const [searchCatSegment4d, setSearchCatSegment4d] = useState("");
  const [debouncedCatSegment4d] = useDebouncedValue(searchCatSegment4d, 500);
  const [searchCatSegment5e, setSearchCatSegment5e] = useState("");
  const [debouncedCatSegment5e] = useDebouncedValue(searchCatSegment5e, 500);
  const [searchCatSegment6f, setSearchCatSegment6f] = useState("");
  const [debouncedCatSegment6f] = useDebouncedValue(searchCatSegment6f, 500);

  const [visible, { toggle, close, open }] = useDisclosure(false);

  //NCC
  const [dataVendor, setDataVendor] = useState<ComboboxItem[]>([]);
  //Loại
  const [dataCatSegment3c, setDataCatSegment3c] = useState<ComboboxItem[]>([]);
  const [dataCatSegment3cFirst, setDataCatSegment3cFirst] = useState<
    ComboboxItem[]
  >([]);
  //Chủng
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);
  //Nhóm
  const [dataCatSegment5e, setDataCatSegment5e] = useState<ComboboxItem[]>([]);
  //Model
  const [dataCatSegment6f, setDataCatSegment6f] = useState<ComboboxItem[]>([]);
  //Brand
  const [dataBrand, setDataBrand] = useState<ComboboxItem[]>([]);
  //Thangton
  const thangTonOptions = [
    { label: "Tồn dưới 1 tháng", value: "Ton1" },
    { label: "Tồn từ 1 đến 3 tháng", value: "Ton1-3" },
    { label: "Tồn từ 3 đến 6 tháng", value: "Ton3-6" },
    { label: "Tồn từ 6 đến 9 tháng", value: "Ton6-9" },
    { label: "Tồn từ 9 đến 12 tháng", value: "Ton9-12" },
    { label: "Tồn từ 1 năm đến 2 năm", value: "Ton1Nam-2Nam" },
    { label: "Tồn trên 2 năm", value: "Ton tren 2Nam" },
  ];

  const sizeGrid = { base: 6, sm: 6, md: 4, lg: 4, xl: 2 };
  const [rowCount, setRowCount] = useState(0);
  const [search, setSearch] = useState({
    keySearch: "",
    serial: "",
    branchCode: [],
    invCode: [],
    itemCode: [],
    MaChungs: [],
    MaNganhs: [],
    MaLoais: [],
    MaModels: [],
    MaHangSxs: [],
    MaNhoms: [],
    ThangTons: [],
  });
  const handleChangeSearchValue = (value: string[] | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : [],
    }));
  };
  const handleChangeSearch = (value: string | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : 0,
    }));
  };

  const columns = React.useMemo<MRT_ColumnDef<InventorySerialItem>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      // Chi nhánh/kho
      {
        accessorKey: "branchCode",
        header: "Mã chi nhánh",
        size: 150,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Button
              variant="light"
              p="4px 8px"
              radius="xl"
              size="xs"
              color="violet"
              fw="bold"
            >
              {renderedCellValue}
            </Button>
          ) : (
            <></>
          ),
      },
      { accessorKey: "branchName", header: "Tên chi nhánh" },
      { accessorKey: "maKho", header: "Mã kho" },
      { accessorKey: "tenKho", header: "Tên kho" },
      // Sản phẩm
      {
        accessorKey: "maSp",
        header: "Mã sản phẩm",
        size: 150,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue === "Tổng" ? (
            <Badge color="green">{renderedCellValue}</Badge>
          ) : (
            <Badge variant="dot" color="green">
              {renderedCellValue}
            </Badge>
          ),
      },
      { accessorKey: "tenSp", header: "Tên sản phẩm", size: 300 },
      { accessorKey: "maBarcode", header: "Mã barcode" },
      { accessorKey: "dvt", header: "Đơn vị tính" },
      // Số lượng
      { accessorKey: "soLuong", header: "Số lượng thực tế" },
      { accessorKey: "countSoLuong", header: "Số lượng tổng" },
      { accessorKey: "countSlChoXuat", header: "Số lượng chờ xuất" },
      // Ngày nhập, phiếu nhập
      { accessorKey: "ngayNhap", header: "Ngày nhập" },
      { accessorKey: "soPhieuNhap", header: "Số phiếu nhập" },
      // Tuổi tồn, giá nhập
      { accessorKey: "tuoiTon", header: "Tuổi tồn" },
      {
        accessorKey: "thangTon",
        header: "Tháng tồn",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueThangTon(String(renderedCellValue))}
          </Text>
        ),
      },
      {
        accessorKey: "donGiaNhap",
        header: "Đơn giá nhập",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue == 0 ? (
            <Text fw={500} size="11.5px">
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      // Vật tư
      { accessorKey: "maVt", header: "Mã vật tư" },
      { accessorKey: "tenVt", header: "Tên vật tư" },
      // Nhà cung cấp
      { accessorKey: "maNcc", header: "Mã NCC" },
      { accessorKey: "tenNcc", header: "Tên NCC" },
      // Chủng, nhóm, ngành, loại, model, hãng SX
      { accessorKey: "maChung", header: "Mã chủng" },
      { accessorKey: "tenChung", header: "Tên chủng" },
      { accessorKey: "maNhom", header: "Mã nhóm" },
      { accessorKey: "tenNhom", header: "Tên nhóm" },
      { accessorKey: "maNganh", header: "Mã ngành" },
      { accessorKey: "tenNganh", header: "Tên ngành" },
      { accessorKey: "maLoai", header: "Mã loại" },
      { accessorKey: "tenLoai", header: "Tên loại" },
      { accessorKey: "maModel", header: "Mã model" },
      { accessorKey: "tenModel", header: "Tên model" },
      { accessorKey: "maHangSx", header: "Mã hãng SX" },
      { accessorKey: "tenHangSx", header: "Tên hãng SX" },
      {
        accessorKey: "plvt1Code",
        header: "Mã plvt 1",
      },
      {
        accessorKey: "plvt1Name",
        header: "Tên plvt 1",
      },
      {
        accessorKey: "plvt3Code",
        header: "Mã plvt 3",
      },
      {
        accessorKey: "plvt3Name",
        header: "Tên plvt 3",
      },
      {
        accessorKey: "plvt4Code",
        header: "Mã plvt 4",
      },
      {
        accessorKey: "plvt4Name",
        header: "Tên plvt 4",
      },
      {
        accessorKey: "plvt5Code",
        header: "Mã plvt 5",
      },
      {
        accessorKey: "plvt5Name",
        header: "Tên plvt 5",
      },
      {
        accessorKey: "plvt6Code",
        header: "Mã plvt 6",
      },
      {
        accessorKey: "plvt6Name",
        header: "Tên plvt 6",
      },
      {
        accessorKey: "maTrangThaiSerial",
        header: "Mã trạng thái serial",
      },
      {
        accessorKey: "trangThaiSerial",
        header: "Trạng thái serial",
      },
      {
        accessorKey: "ghiChuTrangThaiSerial",
        header: "Ghi chú trạng thái serial",
        size: 500,
      },
    ],
    []
  );

  const getValueThangTon = (value: string) => {
    switch (value) {
      case "Ton1":
        return "Tồn dưới 1 tháng";
      case "Ton1-3":
        return "Tồn từ 1 đến 3 tháng";
      case "Ton3-6":
        return "Tồn từ 3 đến 6 tháng";
      case "Ton6-9":
        return "Tồn từ 6 đến 9 tháng";
      case "Ton9-12":
        return "Tồn từ 9 đến 12 tháng";
      case "Ton1Nam-2Nam":
        return "Tồn từ 1 năm đến 2 năm";
      case "Ton tren 2Nam":
        return "Tồn trên 2 năm";
      case null:
      case "null":
      case "":
        return "";
    }
  };

  const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
    </Group>
  );
  const renderMultiSelectOptionBrachCide: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>
        {dataSaleChannel.find((x) => x.value === option.value)?.label}
      </Text>
    </Group>
  );
  const renderMultiSelectOptionInvCode: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>
        {dataInvCode.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Group>
  );
  // Sử dụng debounce để trì hoãn việc gọi API
  const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    if (value.length >= 3) {
      DataItemCode(value); // Gọi API với từ khóa tìm kiếm
    }
  }, 500);

  const handleCleanKeySearch = (str: string) => {
    if (typeof str !== "string") {
      return "";
    }

    let cleaned = str.replace(/;+/g, ";").replace(/;\s*$/, "");
    return cleaned;
  };

  const filterDataByString = () => {
    const numbers = handleCleanKeySearch(debouncedCatSegment3c);

    const filteredData = dataCatSegment3c.filter((item) =>
      item.value?.includes(numbers)
    );

    return filteredData;
  };

  const sortData = () => {
    const numbers = handleCleanKeySearch(debouncedCatSegment3c)
      .split(";")
      .map((num) => num.trim());

    const matched = dataCatSegment3cFirst.filter((item) =>
      numbers.includes(item.value)
    );
    const unmatched = dataCatSegment3cFirst.filter(
      (item) => !numbers.includes(item.value)
    );

    const result = [...matched, ...unmatched];

    return result;
  };

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${pagination.pageSize
      }`;
    if (search.invCode && search.invCode.length > 0) {
      search.invCode.forEach((invCode) => {
        url += `&InvCode=${invCode}`;
      });
    }
    if (search.branchCode && search.branchCode.length > 0) {
      search.branchCode.forEach((branchCode) => {
        url += `&BranchCode=${branchCode}`;
      });
    }
    if (search.itemCode && search.itemCode.length > 0) {
      search.itemCode.forEach((itemCode) => {
        url += `&ItemCode=${itemCode}`;
      });
    }
    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
    }
    if (search.serial) {
      url += `&SerialList=${search.serial}`;
    }
    if (searchCatSegment3c.length > 0) {
      const searchData = handleCleanKeySearch(searchCatSegment3c)
        ?.split(";")
        ?.map((item: any) => `&MaLoais=${item?.trim()}`);
      url += searchData.join("");
    }
    if (searchCatSegment4d.length > 0) {
      const searchData = handleCleanKeySearch(searchCatSegment4d)
        ?.split(";")
        ?.map((item: any) => `&MaChungs=${item?.trim()}`);
      url += searchData.join("");
    }
    if (searchCatSegment5e.length > 0) {
      const searchData = handleCleanKeySearch(searchCatSegment5e)
        ?.split(";")
        ?.map((item: any) => `&MaNhoms=${item?.trim()}`);
      url += searchData.join("");
    }
    if (searchCatSegment6f.length > 0) {
      const searchData = handleCleanKeySearch(searchCatSegment6f)
        ?.split(";")
        ?.map((item: any) => `&MaModels=${item?.trim()}`);
      url += searchData.join("");
    }
    if (search.MaHangSxs && search.MaHangSxs.length > 0) {
      search.MaHangSxs.forEach((item) => {
        url += `&MaHangSxs=${item}`;
      });
    }
    if (search.MaNganhs && search.MaNganhs.length > 0) {
      search.MaNganhs.forEach((item) => {
        url += `&MaNganhs=${item}`;
      });
    }
    if (search.ThangTons && search.ThangTons.length > 0) {
      search.ThangTons.forEach((item) => {
        url += `&ThangTons=${item}`;
      });
    }
    try {
      // const response = await repositoryDelivery.get(
      //   `/api/v1/TblInventorySerialOnhand/get-list-serial-v2?${url}`
      // );
      const response = await repositoryDelivery.get(
        `/api/v1/TblInventorySerialOnhand/get-list-serial-new${url}`
      );
      if (response && response.success) {
        const result = response.data;

        // Kiểm tra nếu không có items hoặc items rỗng
        if (!result?.items || result.items.length === 0) {
          setData([]);
          setRowCount(0);
          table.resetRowSelection();
        } else {
          const mapObjectToNull = Object.fromEntries(
            Object.keys(result?.items[0]).map((key) => [key, null])
          );
          setData([
            {
              ...mapObjectToNull,
              maSp: "Tổng",
              soLuong: result.totalSoLuong,
              donGiaNhap: result.totalDonGiaNhap,
            },
            ...result?.items,
          ]);
          setRowCount(response.totalCount);
          table.resetRowSelection();
        }
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  // Export excel
  const exportDataExcel = async () => {
    open(); // Hiển thị loading
    try {
      // Khởi tạo URL với các tham số phân trang
      let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${pagination.pageSize
        }`;
      if (search.invCode && search.invCode.length > 0) {
        search.invCode.forEach((invCode) => {
          url += `&InvCode=${invCode}`;
        });
      }
      if (search.branchCode && search.branchCode.length > 0) {
        search.branchCode.forEach((branchCode) => {
          url += `&BranchCode=${branchCode}`;
        });
      }
      if (search.itemCode && search.itemCode.length > 0) {
        search.itemCode.forEach((itemCode) => {
          url += `&ItemCode=${itemCode}`;
        });
      }
      if (search.keySearch) {
        url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      if (search.serial) {
        url += `&SerialList=${search.serial}`;
      }
      if (searchCatSegment3c.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment3c)
          ?.split(";")
          ?.map((item: any) => `&MaLoais=${item?.trim()}`);
        url += searchData.join("");
      }
      if (searchCatSegment4d.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment4d)
          ?.split(";")
          ?.map((item: any) => `&MaChungs=${item?.trim()}`);
        url += searchData.join("");
      }
      if (searchCatSegment5e.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment5e)
          ?.split(";")
          ?.map((item: any) => `&MaNhoms=${item?.trim()}`);
        url += searchData.join("");
      }
      if (searchCatSegment6f.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment6f)
          ?.split(";")
          ?.map((item: any) => `&MaModels=${item?.trim()}`);
        url += searchData.join("");
      }
      if (search.MaHangSxs && search.MaHangSxs.length > 0) {
        search.MaHangSxs.forEach((item) => {
          url += `&MaHangSxs=${item}`;
        });
      }
      if (search.MaNganhs && search.MaNganhs.length > 0) {
        search.MaNganhs.forEach((item) => {
          url += `&MaNganhs=${item}`;
        });
      }
      if (search.ThangTons && search.ThangTons.length > 0) {
        search.ThangTons.forEach((item) => {
          url += `&ThangTons=${item}`;
        });
      }
      // Xây dựng URL API cuối cùng
      const baseUrl = `/api/v1/ExportExcel/export-inventory-serial-report-new${url}`;
      const _url = BASE_API_DELIVERY + baseUrl;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename = "bao_cao_ban_hang_theo_ngay.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!"
      );
    } finally {
      close(); // Đóng loading
    }
  };

  // Hàm lấy dữ liệu mã kho
  const DataInvCode = async () => {
    try {
      // const response = await repositoryPos.get(
      //   `/api/v1/TblDmInventory/get-all?checkAuth=true`
      // );
      // if (response && response.httpStatusCode === 200) {
      //   const transformedData = response.data
      //     .filter((i: any) => i.value && i.text)
      //     .map((item: any) => {
      //       const match = item.text.match(/\[(.*?)\]/);
      //       const fullLabel = match ? match[1].trim() : item.text;
      //       return {
      //         value: item.value,
      //         label: item.text,
      //         fullLabel: fullLabel, 
      //       };
      //     });

      //   setDataInvCode(transformedData);
      // }
      const branchSearch = dataSaleChannel.length > 0 && search?.branchCode?.length > 0
        ? search?.branchCode
          .map((branchCode: string) => {
            const branch = dataSaleChannel.find((b) => b.value === branchCode);
            return branch ? `&BranchId=${branch.id}` : "";
          })
          .join("")
        : "";

      const take = search?.branchCode?.length * 100;

      const res = await repositoryDelivery.get<MessageResponse<any>>(
        `/api/v1/TblDmInventory/get-list-by-branchs?Skip=0&Take=${search?.branchCode && search?.branchCode?.length > 0 ? take : 100
        }${branchSearch}`
      );

      if (res && res.success) {
        const result = res.data;
        const data = result
          ?.filter((item: any) => item.idBranch && item.name)
          ?.map((item: any) => ({
            label: `${item.code} - ${item.name}`,
            value: item.code?.toString(),
          }));
        setDataInvCode(data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  // Hàm lấy dữ liệu mã chi nhánh
  const DataBrachCode = async () => {
    try {
      const response = await repositoryPos.get(
        `api/v1/TblDmInventory/get-select-branch?auth=true`
      );
      if (response && response.success) {
        const transformedData = response.data
          .filter((i: any) => i.att2 && i.text)
          .map((item: any) => {
            return {
              value: item.att2,
              label: item.att2 + " - " + item.text,
              id: item.value,
            };
          });

        setDataBranchCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  // Hàm lấy dữ liệu mã sản phẩm
  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      // const response = await repositoryDelivery.get(
      //   `api/v1/TblInventorySerialOnhand/get-list-item-by-inv?Skip=0&Take=50` +
      //     url
      // );
      const response = await repositoryPos.get(
        `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`
      );
      if (response && response.success) {
        // const transformedData = response.data
        //   ?.filter((i: any) => i.maSp && i.tenSp)
        //   .map((branch: any) => ({
        //     value: branch.maSp,
        //     label: branch.maSp + " - " + branch.tenSp,
        //   }));
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text)
          .map((branch: any) => ({
            value: branch.value,
            label: branch.text,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value))
        ).map((value) =>
          transformedData.find((item: any) => item.value === value)
        );
        setDataItemCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  //Hãng sản xuất
  const getDataBrand = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmBrand/get-all"
    );

    if (res && res?.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.text !== null && item.att1 !== null)
        ?.map((item: any) => ({
          label: `${item.att1} - ${item.text}`,
          // value: item.att1?.toString(),
          value: item.text?.toString(),
        }));
      setDataBrand(dataAPI);
    }
  };

  //Call API NCC
  const fetchDataVendorSelect = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblVendor/get-all"
    );

    if (res && res.success) {
      const dataAPI = res.data;
      setDataVendor(
        dataAPI
          ?.filter(
            (item: any) => item.vendorCode != null && item.vendorName != null
          )
          ?.map((item: any) => ({
            value: item.vendorCode?.toString(),
            label: `${item.vendorCode} - ${item.vendorName}`,
          }))
      );
    }
  };

  //Call API Loại
  const fetchCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all"
    );

    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment3c(dataAPI);
      setDataCatSegment3cFirst(dataAPI);
    }
  };

  //Call API Chủng
  const fetchCatSegment4d = async () => {
    let url = "/api/v1/TblCatSegment4d/get-list?Skip=0&Take=30";

    if (searchCatSegment3c.length > 0) {
      const searchML = handleCleanKeySearch(searchCatSegment3c).split(";");

      searchML.forEach((item) => {
        url += `&listCodeSegmentString3=${encodeURIComponent(item)}`;
      });
    }

    if (
      typeof searchCatSegment4d === "string" &&
      searchCatSegment4d?.trim()?.length > 0 &&
      !searchCatSegment4d.includes(";")
    ) {
      url += `&KeySearch=${searchCatSegment4d}`;
    } else if (
      typeof searchCatSegment4d === "string" &&
      searchCatSegment4d?.trim()?.length > 0 &&
      searchCatSegment4d.includes(";")
    ) {
      url += `&CodeString=${handleCleanKeySearch(searchCatSegment4d)
        ?.replace(/;/g, ",")
        .replace(/\s/g, "")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment4d(dataAPI);
    }
  };

  //Call API Nhóm
  const fetchCatSegment5e = async () => {
    let url = "/api/v1/TblCatSegment5e/get-list?Skip=0&Take=30";

    if (searchCatSegment4d.length > 0) {
      url += `&ListCodeString4=${handleCleanKeySearch(searchCatSegment4d)}`;
    }

    if (
      typeof searchCatSegment5e === "string" &&
      searchCatSegment5e?.trim()?.length > 0 &&
      !searchCatSegment5e.includes(";")
    ) {
      url += `&KeySearch=${searchCatSegment5e}`;
    } else if (
      typeof searchCatSegment5e === "string" &&
      searchCatSegment5e?.trim()?.length > 0 &&
      searchCatSegment5e.includes(";")
    ) {
      url += `&CodeString=${handleCleanKeySearch(searchCatSegment5e)
        ?.replace(/;/g, ",")
        .replace(/\s/g, "")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment5e(dataAPI);
    }
  };

  //Call API Model
  const fetchCatSegment6f = async () => {
    let url = "/api/v1/TblCatSegment6f/get-list?Skip=0&Take=30";

    if (searchCatSegment5e.length > 0) {
      const searchMN = handleCleanKeySearch(searchCatSegment5e).split(";");

      searchMN.forEach((item) => {
        url += `&listCodeSegmentString5=${encodeURIComponent(item)}`;
      });
    }

    if (
      typeof searchCatSegment6f === "string" &&
      searchCatSegment6f?.trim()?.length > 0 &&
      !searchCatSegment6f.includes(";")
    ) {
      url += `&KeySearch=${searchCatSegment6f}`;
    } else if (
      typeof searchCatSegment6f === "string" &&
      searchCatSegment6f?.trim()?.length > 0 &&
      searchCatSegment6f.includes(";")
    ) {
      url += `&CodeString=${handleCleanKeySearch(searchCatSegment6f)
        ?.replace(/;/g, ",")
        .replace(/\s/g, "")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment6f(dataAPI);
    }
  };

  //Hãng sản xuất ui select
  const renderMultiSelectOptionBrand: MultiSelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
      {checked && <IconCheck size={12} color="gray" />}
      <Text size="sm">
        {dataBrand.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Flex>
  );

  // rennder Loại
  const menuCatSegment3c = useMemo(() => {
    if (dataCatSegment3c.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment3c.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment3c.includes(item.value)
            ? searchCatSegment3c
              .split(";")
              .filter((val) => val.trim() !== item.value)
              .join(";")
            : searchCatSegment3c === ""
              ? item.value
              : `${searchCatSegment3c};${item.value}`;

          setSearchCatSegment3c(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment3c.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment3c, searchCatSegment3c]);

  // Rennder Chủng
  const menuCatSegment4d = useMemo(() => {
    if (dataCatSegment4d.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment4d.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment4d.includes(item.value)
            ? searchCatSegment4d
              .split(";")
              .filter((val) => val.trim() !== item.value)
              .join(";")
            : searchCatSegment4d === ""
              ? item.value
              : `${searchCatSegment4d};${item.value}`;

          setSearchCatSegment4d(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment4d.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment4d, searchCatSegment4d]);

  // Rennder Nhóm
  const menuCatSegment5e = useMemo(() => {
    if (dataCatSegment5e.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment5e.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment5e.includes(item.value)
            ? searchCatSegment5e
              .split(";")
              .filter((val) => val.trim() !== item.value)
              .join(";")
            : searchCatSegment5e === ""
              ? item.value
              : `${searchCatSegment5e};${item.value}`;

          setSearchCatSegment5e(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment5e.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment5e, searchCatSegment5e]);

  // Rennder Model
  const menuCatSegment6f = useMemo(() => {
    if (dataCatSegment6f.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment6f.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment6f.includes(item.value)
            ? searchCatSegment6f
              .split(";")
              .filter((val) => val.trim() !== item.value)
              .join(";")
            : searchCatSegment6f === ""
              ? item.value
              : `${searchCatSegment6f};${item.value}`;

          setSearchCatSegment6f(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment6f.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment6f, searchCatSegment6f]);

  useEffect(() => {
    if (debouncedCatSegment3c.length === 0) {
      setSearchCatSegment4d("");
      setSearchCatSegment5e("");
      setSearchCatSegment6f("");
    }

    if (!searchCatSegment3c?.includes(";") && searchCatSegment3c.length > 0) {
      setDataCatSegment3c(filterDataByString());
    } else if (searchCatSegment3c?.includes(";")) {
      setDataCatSegment3c(sortData());
    } else if (searchCatSegment3c.length === 0) {
      setDataCatSegment3c(dataCatSegment3cFirst);
    }

    fetchCatSegment4d();
  }, [debouncedCatSegment3c]);

  useEffect(() => {
    if (debouncedCatSegment4d.length === 0) {
      setSearchCatSegment5e("");
      setSearchCatSegment6f("");
    }

    fetchCatSegment4d();
    fetchCatSegment5e();
  }, [debouncedCatSegment4d]);

  useEffect(() => {
    if (debouncedCatSegment5e.length > 0) {
      setSearchCatSegment6f("");
    }

    fetchCatSegment6f();
    fetchCatSegment5e();
  }, [debouncedCatSegment5e]);

  useEffect(() => {
    fetchCatSegment6f();
  }, [debouncedCatSegment6f]);

  useEffect(() => {
    const runAsyncFunctions = async () => {
      await Promise.all([fetchCatSegment3c()]);
    };
    const nextuse = async () => {
      await runAsyncFunctions();
    };
    nextuse();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);
  useEffect(() => {
    DataInvCode();
  }, [search.branchCode])

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableStickyFooter: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,
    rowCount,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "maSp"],
        right: ["statusName"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    // getRowId: (row) => row.departmentId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (145 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  return (
    <Box>
      <LoadingOverlayCustom visible={visible} />
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Group justify="space-between" gap={0}>
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => {
              exportDataExcel();
            }}
          >
            Export Excel
          </Button>
        </Group>
        <Grid mt={10}>
          {/* keysearch */}
          <Grid.Col span={sizeGrid}>
            <Input
              placeholder="Nhập tìm kiếm"
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearch(e.target.value ?? "", "keySearch");
              }}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          {/* Chi nhánh */}
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Chi nhánh"
              clearable
              searchable
              value={search.branchCode}
              data={dataSaleChannel.map((x) => x.value)}
              leftSection={<IconBuildingSkyscraper size={20} color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value ? value : null, "branchCode");
              }}
              renderOption={renderMultiSelectOptionBrachCide}
              onClick={() => {
                if (dataSaleChannel.length === 0) {
                  DataBrachCode();
                }
              }}
            />
          </Grid.Col>
          {/* Kho */}
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Mã kho"
              searchable
              clearable
              // data={dataInvCode
              //   .map((x) => x.fullLabel)
              //   .filter((label): label is string => label !== undefined)}
              data={dataInvCode}
              value={search.invCode}
              renderOption={renderMultiSelectOptionInvCode}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              onClick={() => {
                if (dataInvCode.length === 0) {
                  DataInvCode();
                }
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "invCode");
              }}
            />
          </Grid.Col>

          {/* Mã sp */}
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Nhập mã sản phẩm"
              clearable
              searchable
              data={dataItemCode.map((x) => x.value)} // Hiển thị kết quả từ API
              value={search.itemCode}
              renderOption={renderMultiSelectOption}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              onSearchChange={(value) => {
                debouncedDataItemCode(value); // Sử dụng debounce
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "itemCode");
              }}
            />
          </Grid.Col>

          {/* Mã loại */}
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã loại"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => {
                          setSearchCatSegment3c("");
                          setDataCatSegment3c(dataCatSegment3cFirst);
                        }}
                        style={{
                          display:
                            searchCatSegment3c.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment3c}
                    onChange={(e) => {
                      setSearchCatSegment3c(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment3c.length <= 1
                        ? 32
                        : dataCatSegment3c.length === 2
                          ? 64
                          : dataCatSegment3c.length === 3
                            ? 96
                            : dataCatSegment3c.length === 4
                              ? 128
                              : dataCatSegment3c.length === 5
                                ? 160
                                : dataCatSegment3c.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment3c}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          {/* Mã chủng */}
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã chủng"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchCatSegment4d("")}
                        style={{
                          display:
                            searchCatSegment4d.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment4d}
                    onClick={() => {
                      if (dataCatSegment4d.length === 0) {
                        fetchCatSegment4d();
                      }
                    }}
                    onChange={(e) => {
                      setSearchCatSegment4d(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment4d.length <= 1
                        ? 32
                        : dataCatSegment4d.length === 2
                          ? 64
                          : dataCatSegment4d.length === 3
                            ? 96
                            : dataCatSegment4d.length === 4
                              ? 128
                              : dataCatSegment4d.length === 5
                                ? 160
                                : dataCatSegment4d.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment4d}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>

          {/* Mã nhóm */}
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã nhóm"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchCatSegment5e("")}
                        style={{
                          display:
                            searchCatSegment5e.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment5e}
                    onClick={() => {
                      if (dataCatSegment5e.length === 0) {
                        fetchCatSegment5e();
                      }
                    }}
                    onChange={(e) => {
                      setSearchCatSegment5e(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment5e.length <= 1
                        ? 32
                        : dataCatSegment5e.length === 2
                          ? 64
                          : dataCatSegment5e.length === 3
                            ? 96
                            : dataCatSegment5e.length === 4
                              ? 128
                              : dataCatSegment5e.length === 5
                                ? 160
                                : dataCatSegment5e.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment5e}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>

          {/* Mã model */}
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã model"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchCatSegment6f("")}
                        style={{
                          display:
                            searchCatSegment6f.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment6f}
                    onClick={() => {
                      if (dataCatSegment6f.length === 0) {
                        fetchCatSegment6f();
                      }
                    }}
                    onChange={(e) => {
                      setSearchCatSegment6f(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment6f.length <= 1
                        ? 32
                        : dataCatSegment6f.length === 2
                          ? 64
                          : dataCatSegment6f.length === 3
                            ? 96
                            : dataCatSegment6f.length === 4
                              ? 128
                              : dataCatSegment6f.length === 5
                                ? 160
                                : dataCatSegment6f.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment6f}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>

          {/* Mã hãng sản xuất */}
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Mã hãng sản xuất"
              clearable
              searchable
              data={dataBrand}
              renderOption={renderMultiSelectOptionBrand}
              leftSection={<IconTrademark size={20} color="#15aabf" />}
              onClick={() => {
                if (dataBrand.length === 0) {
                  getDataBrand();
                }
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "MaHangSxs");
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Tháng tồn"
              data={thangTonOptions}
              clearable
              leftSection={<IconCalendar color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value, "ThangTons");
              }}
            />
          </Grid.Col>
          {/* Mã nhà cung cấp */}
          {/* <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Nhập mã NCC"
              type="text"
              data={dataVendor}
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              searchable
              clearable
              onClick={() => {
                if (dataVendor.length === 0) {
                  fetchDataVendorSelect();
                }
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "");
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col> */}

          <Grid.Col span={sizeGrid}>
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default ReportInventoryBySerial;
